import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Displays a duration in hours and minutes format
 * @param {Object} props
 * @param {number} props.value - The duration value in decimal hours (e.g., 1.5 for 1 hour and 30 minutes)
 * @returns {JSX.Element} Formatted duration string
 */
const DurationDisplay = ({ value }) => {
  const { t } = useTranslation();

  const hours = Math.floor(value);
  const minutes = Math.round((value - hours) * 60);
  // Handle case where all minutes are converted to an additional hour
  if (minutes === 60) {
    return (
      <>
        {t("durationHoursOnly", {
          hours: hours + 1,
          defaultValue: `${hours + 1} hours`,
        })}
      </>
    );
  }

  // If hours is zero, only show minutes
  if (hours === 0) {
    return (
      <>
        {t("durationMinutesOnly", {
          minutes,
          defaultValue: `${minutes} minutes`,
        })}
      </>
    );
  }

  // If minutes is zero, only show hours
  if (minutes === 0) {
    return (
      <>
        {t("durationHoursOnly", {
          hours,
          defaultValue: `${hours} hours`,
        })}
      </>
    );
  }

  // Show both hours and minutes
  return (
    <>
      {t("duration", {
        hours,
        minutes,
        defaultValue: `${hours} hours and ${minutes} minutes`,
      })}
    </>
  );
};

export default DurationDisplay;
